import Image from 'next/image'
import useTranslation from 'next-translate/useTranslation'

function RuleItem({ copy, image, title, first }: RuleItemProps) {
  const { t } = useTranslation('wellBeing')

  return (
    <div className="flex flex-col items-center justify-start h-full my-4">
      <p className="text-xl font-black text-center xs:text-sm xl:text-base text-violet-150">
        {t(`${title}`)}
      </p>
      <div className="w-24 h-24 my-8 xs:w-16 xs:h-16 xl:w-24 xl:h-24">
        <Image
          alt={t('results.none')}
          src={`/images/well-being/${image}.png`}
          height="10%"
          width="10%"
          layout="responsive"
          quality={75}
          loading="eager"
        />
      </div>
      {first ? (
        <>
          <li className="text-sm text-center xs:text-xs xl:text-sm text-violet-150">
            {t(`${copy}`)}
          </li>
          <li className="text-sm text-center xs:text-xs xl:text-sm text-violet-150">
            {t(`${first}`)}
          </li>
        </>
      ) : (
        <p className="text-sm text-center xs:text-xs xl:text-sm text-violet-150">
          {t(`${copy}`)}
        </p>
      )}
    </div>
  )
}

type RuleItemProps = {
  copy: string
  image: string
  first?: string
  title: string
}

export default RuleItem
